export default __webpack_public_path__ + "media/images/User_Business_Male-9f07108c8f5e29df8fc373ca66b1984d.png";